export default class BookmakerAssetModel {
  public logo: string = null;
  public type: string = null;
  public transparentBackgroundUrl: string = null;
  public backgroundColor: string = null;
}
